import nanoId from "../utils/nanoid"

/**
 * (c) Prof. Dr. Ulrich Anders
 *
 * Creates an empty person.
 * @param {string} rId - person Id, if not set it gets a nanoId()
 * @returns {object} personNew - person created
 */
const personCreate = (rId) => {
  let personNew = {
    rId: rId ? rId : nanoId(),
    nameLast: "",
    nameFirst: "",
    nameDisplayShort: "",
    nameDisplayLong: "",
    academicTitle: "",
    company: "",
    jobFunction: "",
    projectRole: "",
    email: "",
    phone: "",
    url: "",
    avatar: "",
  }
  return personNew
}

export default personCreate
